export enum APPLICATION_FLOW_TYPE {
  MAIN = 'Main',
  NEW_WELCOME_PAGE = 'NewWelcomePage',
}
